import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ViewportFullscreenNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M21 1.20001H15V4.80001H19.2V9.00001H22.8V3.00001C22.8 2.00621 21.9938 1.20001 21 1.20001Z"
        fill={color}
      />
      <path
        d="M19.2 19.2H15V22.8H21C21.9938 22.8 22.8 21.9937 22.8 21V15H19.2V19.2Z"
        fill={color}
      />
      <path
        d="M4.80001 15H1.20001V21C1.20001 21.9937 2.00631 22.8 3.00001 22.8H9.00001V19.2H4.80001V15Z"
        fill={color}
      />
      <path
        d="M1.20001 3.00001V9.00001H4.80001V4.80001H9.00001V1.20001H3.00001C2.00631 1.20001 1.20001 2.00621 1.20001 3.00001Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ViewportFullscreenNsk.displayName = 'ViewportFullscreenNsk';
